import { languageLocale } from '../i18n';

/**
 * Formatting shared by the model price markers and the promotion banner.
 * Times are rendered in the browser's zone and, where a schedule is involved,
 * in UTC as well: off-peak windows are defined in UTC.
 */

/** "−20%" with a true minus sign; at most one decimal ("−12.5%"). */
export function formatPercentOff(percent: number) {
  const value = new Intl.NumberFormat(languageLocale(), { maximumFractionDigits: 1 }).format(
    Math.abs(percent),
  );
  return `−${value}%`;
}

/** A usable percentage, or null when the reduction is not one uniform percent. */
export function percentOffOrNull(percent: number | null | undefined) {
  return typeof percent === 'number' && Number.isFinite(percent) && percent > 0 ? percent : null;
}

export function parseInstant(value: string | null | undefined) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** "01:00" (24-hour), in UTC or the browser's zone. */
export function formatClock(date: Date, timeZone?: 'UTC') {
  return new Intl.DateTimeFormat(languageLocale(), {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone,
  }).format(date);
}

/** "Nov 30, 16:00" (24-hour), in UTC or the browser's zone. */
export function formatDayClock(date: Date, timeZone?: 'UTC') {
  return new Intl.DateTimeFormat(languageLocale(), {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone,
  }).format(date);
}
